module.exports = __webpack_public_path__ + "f664712e7e9901e6f6586ba9ecc117fa.png";